import React from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { PXTextModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXTextModalWrapper';

const Layout = () => {
  const { clearModalCollection } = useModalContext();
  const { setPageContentCollection } = usePageContentContext();
  const afterSuccessfulSubmission = (resp) => {
    clearModalCollection();
    setPageContentCollection(resp);
  };

  return (
    <PXTextModalWrapper
      onSubmitSucces={afterSuccessfulSubmission}
      buttonLabel={'Finish →'}
    >
      <MetaControlField attr={'description'} />
    </PXTextModalWrapper>);
};

export default Layout;
